<script lang="ts" setup>
  import type { PropType } from 'vue';
  import type { SaleOfferMessage, SaleOfferQuotation } from '@storefront/storefront';
  import { StoreLayout, AccountLayout } from '@storefront/components';

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });


  defineProps({
    offer: { type: Object, required: true },
    messages: { type: Array as PropType<SaleOfferMessage[]>, required: true },
    quotations: { type: Object as PropType<SaleOfferQuotation>, required: true },
  });
</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.offers.index')">
    {{ $t('SHOP.ACCOUNT.HEADER.SALE_OFFER_NUMBER', { number: offer.id }) }}
  </AccountMobileNavigation>
  <OfferDetailsView :messages="messages" :offer="offer" :quotations="quotations" />

  <RouterView />
</template>
